import { useState, useEffect } from 'react';
import { contentService, ContentData } from '../services/contentService';
import contentData from '../data/content.json';

export const useContent = () => {
  const [content, setContent] = useState<ContentData>(contentData as ContentData);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadContent = async () => {
      try {
        const data = await contentService.getContent();
        setContent(data);
      } catch (error) {
        console.error('Failed to load content:', error);
        setContent(contentData);
      } finally {
        setIsLoading(false);
      }
    };

    loadContent();

    const interval = setInterval(loadContent, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return { content, isLoading };
};
